<template>
  <div class="edcity-add-school">
    <v-row>
      <v-col class="m-5">
        <v-text-field
          v-model="form.product_code"
          :label="labelHeader('product_code')"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.school_code"
          :label="labelHeader('school_code')"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.school_year"
          :label="labelHeader('school_year')"
          required
        ></v-text-field>
        <br>
        <v-text-field
          v-model="form.school_contact_name"
          :label="labelHeader('school_contact_name')"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.school_contact_mobile"
          :label="labelHeader('school_contact_mobile')"
          required
        ></v-text-field>
        <v-text-field
          v-model="form.school_contact_email"
          :label="labelHeader('school_contact_email')"
          required
        ></v-text-field>
        <br>
        <v-text-field
          v-model="form.passcode"
          :label="labelHeader('passcode')"
          required
          type="password"
        ></v-text-field>
      </v-col>      
    </v-row>
    <v-row>
      <v-col>
        <v-btn class="primary" @click="addProductToSchoolByYear()">{{ $t("manage.by_edcity.add_school.btn.add_new_school") }}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { api_edcity } from "@/services/dds/api_edcity";
const apiEdCity = new api_edcity(process.env.VUE_APP_BASE_URL);
export default {
  name: "addProductSchool",
  data: function () {
    return {
      current: {
        username: null,
        uid: null,
        user_level: null,
        auth_token: null,
      },
      form: {
        product_code: null,
        school_code: null,
        school_year: null,
        school_contact_name: null,
        school_contact_mobile: null,
        school_contact_email: null,
        passcode: null,
      },
    };
  },
  mounted: function () {
    var self = this;
    self.current.username = self.$store.state.user.username;
    self.current.uid = self.$store.state.user.uid;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
  },  
  methods: {
    labelHeader(label){
      var self = this;
      if(label=="product_code") return self.$t("manage.by_edcity.add_school.product_code");
      else if(label=="school_code") return self.$t("manage.by_edcity.add_school.school_code");
      else if(label=="school_year") return self.$t("manage.by_edcity.add_school.school_year");
      else if(label=="school_contact_name") return self.$t("manage.by_edcity.add_school.school_contact_name");
      else if(label=="school_contact_mobile") return self.$t("manage.by_edcity.add_school.school_contact_mobile");
      else if(label=="school_contact_email") return self.$t("manage.by_edcity.add_school.school_contact_email");
      else if(label=="passcode") return self.$t("manage.by_edcity.add_school.passcode");
    },
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    addProductToSchoolByYear(){
      var self = this;
      
      apiEdCity.addProductToSchoolByYear(self.form.product_code, self.form.school_code, self.form.school_year, self.form.school_contact_name, self.form.school_contact_mobile, self.form.school_contact_email, self.form.passcode)
      .then((response) =>{
        if(response.status=="success"){
          self.$store.commit("showSnackBar", "New School has been added");
          
        }
        else if(response.status=="fail"){
          self.$store.commit("showSnackBar", response.message);
        }
      });      
      

    },
    goTo(school_id){
      var self = this;
      self.$router.push("/management/school/"+school_id);
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>